"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateSyncSettings = exports.fetchSyncSettings = exports.fetchShopifyStoreStatuses = void 0;

var _reduxObservable = require("redux-observable");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var fetchShopifyStoreStatuses = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchShopifyStoreStatuses,
  initiatingActionType: _actions.ShopifyActionTypes.FETCH_STORES_STATUSES,
  requestStatusSelector: _selectors.getFetchShopifyStatusesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchStoresStatusesActions
}));
exports.fetchShopifyStoreStatuses = fetchShopifyStoreStatuses;
var fetchSyncSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchShopifySyncSettings,
  initiatingActionType: _actions.ShopifyActionTypes.FETCH_SYNC_SETTINGS,
  requestStatusSelector: _selectors.getFetchShopifySyncSettingsStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchSyncSettingsActions
}));
exports.fetchSyncSettings = fetchSyncSettings;
var updateSyncSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateShopifySyncSettings,
  initiatingActionType: _actions.ShopifyActionTypes.UPDATE_SYNC_SETTINGS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.UpdateSyncSettingsActions
}));
exports.updateSyncSettings = updateSyncSettings;

var _default = (0, _reduxObservable.combineEpics)(fetchShopifyStoreStatuses, fetchSyncSettings, updateSyncSettings);

exports.default = _default;